<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Communications</h4>
            <div class="row">
              <div class="col-md-12">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                        class="nav-link active show"
                        id="team-announcements-tab"
                        data-toggle="tab"
                        href="#team-announcements"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab='team-announcements'"
                    >Team Announcements</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="announcement-tab"
                        data-toggle="tab"
                        href="#announcements"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab = 'announcement'"
                    >Public Announcements</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="email-tab"
                        data-toggle="tab"
                        href="#emails"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab = 'email'"
                    >Emails</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="predefined-tab"
                        data-toggle="tab"
                        href="#predefinedResponses"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab = 'predefined'"
                    >Predefined Responses</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="automated-tab"
                        data-toggle="tab"
                        href="#automatedMessages"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab = 'automated'"
                    >Automated Messages</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="reminder-tab"
                        data-toggle="tab"
                        href="#reminder"
                        role="tab"
                        aria-controls="up"
                        @click="activeTab = 'Reminders'"
                    >Reminders</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="chat-tab"
                        data-toggle="tab"
                        href="#chat"
                        role="tab"
                        aria-controls="up"
                        @click="loadPresets('Messages')"
                    >Text Messages</a>
                  </li>
                  <li class="nav-item">
                    <a
                        class="nav-link"
                        id="popups-tab"
                        data-toggle="tab"
                        href="#popups"
                        role="tab"
                        aria-controls="up"
                        @click=" loadPresets('Popups')"
                    >Manage Popups</a>
                  </li>
                  <li v-if="user.userType === 'admin' || user.userType === 'super-admin'" class="nav-item">
                    <a
                        @click="activeTab = 'Reports'"
                        class="nav-link"
                        id="reports-tab"
                        data-toggle="tab"
                        href="#reports"
                        role="tab"
                        aria-controls="up"
                    >Reports</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="card-body" style="padding-top: 0 !important">
            <div class="tab-content customer-table">
              <div id="team-announcements" class="tab-pane active show" v-if="activeTab === 'team-announcements'" >
                <TeamAnnouncements/>
              </div>
              <div id="announcements" class="tab-pane fade" v-if="activeTab === 'announcement'">
                <Announcements/>
              </div>
              <div id="emails" class="tab-pane fade" v-if="activeTab === 'email'">
                <Email ref="email"/>
              </div>
              <div id="predefinedResponses" class="tab-pane fade" v-if="activeTab === 'predefined'">
              <PredefinedResponse/>
              </div>
              <div id="automatedMessages" class="tab-pane fade" v-if="activeTab === 'automated'">
              automatedMessages
              </div>
              <div id="reminder" class="tab-pane fade" v-if="activeTab === 'Reminders'">
                <reminder></reminder>
              </div>
              <div id="chat" class="tab-pane fade" v-if="activeTab === 'Messages'">
                <chat ref="textMessages"></chat>
              </div>
              <div id="popups" class="tab-pane fade" v-if="activeTab === 'Popups'">
                <popups :presetMacros="[]" ref="popups"></popups>
              </div>
              <div id="reports" class="tab-pane fade" v-if="activeTab === 'Reports'">
                <reports  ref="reports"></reports>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal_body">
      <div class="modal" tabindex="-1" role="dialog" id="addEmail" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">
                Add Preset For Email
              </h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-if="loading" class="modal-body">
              <div class="loader"></div>
            </div>
            <div v-else class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <button class="btn btn-sm btn-primary" @click="addMacro(' {firstName}')">First Name</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form >
                    <label>Key:</label>
                    <input type="text" class="form-control" required v-model.trim="key">
                    <label>Title:</label>
                    <input type="text" class="form-control" required v-model.trim="title">
                    <label>Message:</label>
                    <textarea class="form-control" required rows="3" v-model="message"></textarea>
                  </form>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button @click="submit()" class="btn btn-primary float-right" type="submit">Submit</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "index",
  components: {
    Announcements: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../views/admin/Announcements/Announcements"
            ),
    TeamAnnouncements: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../views/admin/Announcements/Team-Announcements"
            ),
    Email: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/email"
            ),
    Reminder: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/reminders"
            ),
    Chat: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/chat"
            ),
    Popups: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/popups"
            ),
    Reports: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/reports"
            ),
    PredefinedResponse: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Communications/predefinedResponse"
            ),
  },
  data() {
    return {
      activeTab: 'team-announcements',
      message: '',
      title: '',
      loading: '',
      key: ''
    }
  },
  methods: {
    loadPresets (val) {
      this.activeTab = val;
      this.$refs.textMessages.getPresetReplies()
    },
    showModal(){
      $('#addEmail').modal('show')
    },
    addMacro (macro) {
        this.message += macro
    },
    async submit(){
      try{
        this.loading=true;
        await db.collection('presets').add({
          title: this.title,
          message: this.message,
          key: this.key,
          type: 'email',
          createdAt: new Date().toISOString()
        })
        await this.$refs.email.getPresetsForEmail()
        swal({
          title: "Success",
          text: "You have successfully add preset to email",
          type: "success",
        });
      }
      catch(e){
        console.log(e.toString())
        swal({
          title: "Error",
          text: "Something went wrong while creating preset",
          type: "error",
        });
      }finally {
        this.loading=false
        $('#addEmail').modal('hide');

      }



    }
  }
}
</script>


<style scoped lang="scss">
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.notes-section {
  background-color: #ef8057;
  color: white;
  border-radius: 3px;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
hr {
  border-top: 1px solid rgba(255,255,255,.5);
}
}
table{
tr {
.task-width {
  width:70%;
}
td {
/deep/  p {
  margin: 0 !important;
}
}
}
}
hr {
&.h-3 {
   border-top: 3px solid rgba(0,0,0,.1);
 }
}
.pagination{
  display: inline-flex !important;
}
.cf-status-icons {
i {
  font-size: 25px;
  margin: 0 !important;
&.disabled {
   color: #7E7E7E;
 }

&.enabled {
   color: #47f260;
 }

&.yellow {
   color: #f2b61d;
 }
&.default {
   color: currentColor;
 }
&:hover{
   background-color:transparent !important;
   color: currentColor !important;
 }
}
}
.cpy-btn{
  margin: 0;
}
.fs-10{
  font-size: 10px;
}
.h-43{
  height:43px;
}
.domain-card{
  background: #f0f0f4;
  box-shadow: none;
  border-radius: 8px !important;
&:hover{
   box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.15);;
 }
.collapse-btn{
  margin-top: 0.5rem !important;
}
.domain-head{
  display: flex;
  justify-content: space-between;
.h5-m0 {
  margin: 0;
}
.ul-m0{
  margin: 0;
}
}
.domain-info{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
.badge{
  text-transform: none !important;
}
}
}
.bl-bt{
  display: flex;
  align-items: flex-end;
button {
  margin: 0 !important;
}
}
.cursor-pointer{
  cursor: pointer;
}
pre{
  display: inline-block;
  margin-bottom: 0px;
}
</style>

